import { Link } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/AuthContext';
import DepositAddressCard from './components/DepositAddressCard';
import InfoList from './components/InfoList';
import PasskeyCard from './components/PasskeyCard';
import ProfileHero from './components/ProfileHero';
import WalletSummary from './components/WalletSummary';
import { formatLabel, getDepositInfo, splitProfile } from './format';
import './Account.css';

function AccountPage() {
    const { t } = useTranslation('account');
    const { user } = useAuth();

    if (!user) {
        return (
            <div className="account">
                <div className="page-heading">
                    <div>
                        <h1>{t('heading.title')}</h1>
                        <p>{t('heading.subtitle')}</p>
                    </div>
                </div>
                <section className="panel">
                    <p className="account-empty">{t('empty.profile')}</p>
                </section>
            </div>
        );
    }

    const { fields, groups } = splitProfile(user);
    const deposit = getDepositInfo(user);

    return (
        <div className="account">
            <div className="page-heading">
                <div>
                    <h1>{t('heading.title')}</h1>
                </div>
            </div>

            <div className="account-overview">
                <ProfileHero user={user} />
                <WalletSummary wallet={user.wallet} />
            </div>

            <div className="account-grid">
                <section className="panel" aria-label={t('a11y.profileDetails')}>
                    <div className="section-head">
                        <h2>{t('sections.profile')}</h2>
                    </div>
                    <InfoList items={fields} />
                </section>

                {deposit.address || deposit.qrPayload ? (
                    <DepositAddressCard
                        address={deposit.address}
                        qrPayload={deposit.qrPayload}
                    />
                ) : null}

                {groups.map((group) => (
                    <section key={group.key} className="panel" aria-label={group.key}>
                        <div className="section-head">
                            <h2>{formatLabel(group.key)}</h2>
                        </div>
                        <InfoList
                            items={Object.entries(group.value).map(([key, value]) => ({
                                key,
                                value,
                            }))}
                        />
                    </section>
                ))}
            </div>

            <PasskeyCard />

            <section className="panel account-settings" aria-label={t('a11y.support')}>
                <Link className="account-setting" to="/ecosystem">
                    <strong>{t('links.ecosystem')}</strong>
                    <RightOutlined />
                </Link>
                <Link className="account-setting" to="/help">
                    <strong>{t('links.help')}</strong>
                    <RightOutlined />
                </Link>
            </section>
        </div>
    );
}

export default AccountPage;
